export const pages = [
  {
    virtualPageURL: '/cvc/intro',
    virtualPageTitle: 'Stap 0 - Landing',
  },
  {
    virtualPageURL: '/cvc/codeinput',
    virtualPageTitle: 'Stap 1 - Input code',
  },
  {
    virtualPageURL: '/cvc/codeok',
    virtualPageTitle: 'Stap 2 - Input code is ok',
  },
  {
    virtualPageURL: '/cvc/form',
    virtualPageTitle: 'Stap 3a - input gegevens',
  },
  {
    virtualPageURL: '/cvc/emptyvault',
    virtualPageTitle: 'Stap 3b - leeg geroofd',
  },
  {
    virtualPageURL: '/cvc/tnx',
    virtualPageTitle: 'Stap 4 - check mail',
  },
];
